export const FIELD_TYPE_WITH_OPTIONS = ['select', 'multiselect'];

const isFieldTypeWithOptions = (fieldType?: string | null) =>
  fieldType && FIELD_TYPE_WITH_OPTIONS.indexOf(fieldType) !== -1;

export default isFieldTypeWithOptions;
